module.exports = __webpack_public_path__ + "img/pill.bd870f27.png";